import $ from 'jquery';
import Splide from '@splidejs/splide';

const initChipsTrack = (el) => {
  const splide = new Splide(el, {
    type: 'slide',
    drag: true,
    arrows: false,
    pagination: false,
    trimSpace: false,
    autoWidth: true,
    speed: 600,
    padding: {
      left: 0,
      right: 0,
    },
    mediaQuery: 'min',
    perMove: 1,
    omitEnd: true,
    focus: 'start',

    classes: {
      arrows: 'splide__arrows',
      arrow: 'splide__arrow chips__arrow btn btn--icon-filled',
      prev: 'splide__arrow--prev chips__arrow--prev btn--icon-chevron-left',
      next: 'splide__arrow--next chips__arrow--next btn--icon-chevron-right',
    },
    breakpoints: {
      320: {
        drag: true,
      },
      768: {
        drag: true,
      },
      1024: {
        arrows: false,
      },
    },
  });

  const { Components } = splide;

  splide.on('mounted', () => {
    const selected = splide.Components.Slides.filter('.has-selected');
    const isOverflow = Components.Layout.isOverflow();

    if (selected[0]) {
      if (isOverflow) {
        splide.go(selected[0].index);

        if (selected[0].index !== 0) {
          splide.options = {
            focus: 'center',
            trimSpace: true,
          };
        } else {
          splide.options = {
            focus: 'start',
          };
        }
      } else {
        splide.options = {
          trimSpace: 'move',
        };
      }

      splide.options = {
        arrows: isOverflow,
      };
      const { prev } = Components.Arrows.arrows;

      $(prev).addClass('hidden');
    }
  });

  let windowWidth = 0;

  splide.on('resize', () => {
    const width = $(window).innerWidth();
    const isOverflow = Components.Layout.isOverflow();

    if (width < windowWidth) {
      splide.options = {
        arrows: isOverflow,
      };
    }

    if (!isOverflow) {
      splide.options = {
        trimSpace: true,
        focus: 'start',
      };
    }

    windowWidth = width;
  });

  splide.on('moved', () => {
    const isOverflow = Components.Layout.isOverflow();

    if (isOverflow) {
      splide.options = {
        trimSpace: 'move',
      };
    }

    const firstSlide = Components.Slides.getAt(0).slide;
    const { prev } = Components.Arrows.arrows;

    if (!$(firstSlide).hasClass('is-visible')) {
      $(prev).removeClass('hidden');
    } else {
      $(prev).addClass('hidden');
    }
  });

  splide.on('overflow', (isOverflow) => {
    splide.options = {
      arrows: isOverflow,
      drag: isOverflow,
      padding: {
        left: 0,
        right: 40,
      },
    };
  });

  splide.mount();
};

const setSliderPosition = (slider, state, options, current) => {
  const prev = state.prev ? options[state.prev] : null;
  const prevOffset = prev ? $(prev).parent('li').position().left : 0;
  const currentOffset = $(current).parent('li').position().left;

  const width = $(current).outerWidth(true);

  slider.css({
    left: `${prevOffset}px`,
    width: `${width}px`,
    transform: `translateX(${currentOffset - prevOffset}px)`,
  });
};

const initChipsFilter = (el) => {
  const $parent = $(el);

  const $filterWrapper = $parent.find('.form-item');
  const $filterTrack = $filterWrapper.find('.bef-links');

  const $filterList = $parent.find('.bef-links ul');
  const $filterListItem = $parent.find('.bef-links ul li');

  const $filterOptions = $filterList.find('li a');

  const $slider = $('<li/>', {
    class: 'chips-filter__slider',
  });

  const storedState = sessionStorage.getItem('filterHistory');

  const currentState = storedState ? JSON.parse(storedState) : { prev: null, current: 0 };

  if (!storedState) {
    sessionStorage.setItem('filterHistory', JSON.stringify(currentState));
  }

  if ($filterList.length) {
    $filterList.append($slider);

    $filterWrapper.addClass('splide');
    $filterTrack.addClass('splide__track');
    $filterList.addClass('splide__list');
    $filterListItem.addClass('splide__slide');

    $filterOptions.each((index, option) => {
      $(option).attr('data-key', index);

      if ($(option).hasClass('bef-link--selected')) {
        $(option).parent('li').addClass('has-selected');
        $slider.attr('data-selected', $(option).data('key'));

        if (currentState) {
          setSliderPosition($slider, currentState, $filterOptions, $(option));
        }
      }
    });

    initChipsTrack($filterWrapper.get(0));

    $filterOptions.on('click', (e) => {
      e.preventDefault();
      const $this = $(e.target);

      const state = JSON.parse(sessionStorage.getItem('filterHistory'));

      const filterHistory = {
        prev: currentState.current,
        current: $this.data('key'),
      };

      sessionStorage.setItem('filterHistory', JSON.stringify({ ...state, ...filterHistory }));
    });

    let windowWidth = 0;

    $(window).on('load', () => {
      windowWidth = $(window).width();
    });

    $(window).on('resize', () => {
      if (windowWidth !== $(window).width()) {
        setTimeout(() => {
          setSliderPosition(
            $slider,
            currentState,
            $filterOptions,
            $($filterOptions[currentState.current]),
          );
        }, 100);

        windowWidth = $(window).width();
      }
    });
  }
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstChipsFilter = {
    attach(context) {
      $(window).on('unload', () => {
        sessionStorage.removeItem('filterHistory');
      });

      $('.chips-filter', context).each((index, element) => initChipsFilter(element));
    },
  };
}(window, Drupal));
